export default function phoneMask(value: string): string {
    let newValue = value
    newValue = newValue.replace(/\D/g, '')

    // (11)1111-1111
    newValue = newValue.replace(/^(\d{2})(\d)/g, '($1) $2')
    newValue = newValue.replace(/(\d)(\d{4})$/, '$1-$2')

    return newValue
}
